import styled from 'styled-components'

/*----- Commons -----*/
import Color from '../../commons/Color'

export default styled.main`
	.hero-container {
		background-color: ${ Color.main };
		margin-bottom: 64px;
		overflow: hidden;
		height: 580px;
	}
	.greeting-paragraph {
		display: flex;
		justify-content: center;
		margin-top: -200px;
	}
	.producer-list {
		margin-top: 64px;
	}
	.circle-container {
    overflow: hidden;
    height: 1000px;
    position: absolute;
    right: 0;
    top: -160px;
    max-width: 1000px;
    width: 100%;
		.circle-container__blue-circle {
			position: absolute;
			top: 80px;
			right: -400px;
			z-index: 1;
			width: 900px;
		}
	}
	.loading-more-spinner, .load-more-button {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 32px 0;
	}
	.producers__search-container {
		margin: 64px 0;
		max-width: 350px;
	}
	.search-input {
		box-shadow: none;
		border-bottom: 1px solid grey;
	}
`